// extracted by mini-css-extract-plugin
export default {"radio-item":"styles_radio-item__BnN0c"};